var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_c('project-journal-table')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"text-center mb-4 d-print-none"},[_c('strong',[_vm._v("Project Journal Menu")])])}]

export { render, staticRenderFns }